import { inject } from '@angular/core';

import { CommunicationResourceService } from './communication-resource.service';

export const CommunicationResolver = () => {
    const resource = inject(CommunicationResourceService);
    return resource.getInitValues();
};
